<script>
    import appConfig from '@src/app.config'
	import Layout from '@layouts/newdefault'
    import { giftlistApi } from '@router/apiFiles/giftlistApi'

    /**
     * Page
     */
    export default {
        page: {
            title: 'Busca',
            meta: [{ name: 'description', content: appConfig.description }],
        },
        components: {
            Layout,
        },
        data() {
            return {
                title: 'Home',
                items: [
                    {
                        text: 'Sistema',
                        href: '/',
                    },
                    {
                        text: 'Paginas',
                        href: '/',
                    },
                    {
                        text: 'Home',
                        active: true,
                    },
                ],
                isMaster: false,
				showTable: false,
				result: []
            }
        },
        mounted() {
            if (typeof (this.$route.query.search) !== 'undefined') {
                this.search = this.$route.query.search;
                this.fetchData()
            }
        },
        methods: {			
            async fetchData() {
				var self = this;

                self.result = [];
                self.isBusy = true;
                
                giftlistApi.search({ search: self.search, date: '' })
					.then(function (data) {
                        self.result = data.data;
                        self.isBusy = false;
                        self.showTable = true;
                    });

				//self.result = [];
				//self.result.push({ name: 'LISTA DE PRESENTE - Raissa e Victor', memberName: 'Raissa Oliveira e Victor Costa', type: 'LISTA DE PRESENTE', date: '22/04/2022', city: 'BELO HORIZONTE - MG', url: 'B29202' });
				//self.result.push({ name: 'LISTA DE PRESENTE - Julia e Luiz', memberName: 'Julia Diniz e Luiz Miranda', type: 'LISTA DE PRESENTE', date: '30/04/2022', city: 'BETIM - MG', url: 'B29203' });
				//self.showTable = true;
            },
			async goList(url) {
				this.$router.replace('/lista/' + url)
			},
            getProfileImage(index, imageUrl) {
                if (imageUrl != undefined && imageUrl.length > 0) {
                    return imageUrl;
                }
                else {
                    var total = 16;
                    var imgindex = index > (total - 1) ? ((index % total) + 1) : (index + 1);
                    return `/img/search/WeddingRings${imgindex}.jpg`;
                }
            }
        }
    }
</script>

<template>
    <Layout>
	
		<div class="ext busca-lista">
			<div class="int">
				<div class="giftlist giftlistinfo">
					<h3 class="giftlistinfo-title">Buscar Lista</h3>
					<div class="giftlistinfo-members">
						<div class="blfinput">
							<input v-model="search" class="inputbusca" type="text" placeholder="Digite o nome da noiva, noivo ou a data do evento">
						</div>
						<div class="blfbutton1" @click="fetchData()">
							<div class="btnbusca">
								<img src="https://www.lavillecasa.com.br/arquivos/blfgiftico.png?v=636578511052800000">
								<p>PROCURAR LISTA</p>
							</div>
						</div>
						<input class="inputbuscadata" type="hidden">
					</div>
				</div>
			</div>
		</div>

		<div id="gcontent" class="ext finish-load">
			<div class="int">
				<div id="mesatual" class="content-custom" v-show="showTable">
					<div class="listasdomesconteudo" id="mesatual_counteudo">
						<table class="giftlist-table">
							<thead class="giftlist-header">
								<tr>
									<th class="giftlist-header-image" style="display: none;">Foto</th>
									<th class="giftlist-header-member">Presenteados</th>
								</tr>
							</thead>
							<tbody class="giftlist-body" style="cursor: pointer">
								<tr v-for="(item, index) in result" @click="goList(item.url)" v-bind:key="item.url" class="version-2 type-41 public active visitor-has-access member-has-access has-image has-product">
									<td class="giftlist-body-image">
                                        <img height="165" width="165" v-bind:src="getProfileImage(index, item.imageUrl)">
                                    </td>
									<td class="giftlist-body-member">
                                        <div class="giftlist-body-member-main">
                                            <p>{{String(item.memberName).toLowerCase()}}</p>
                                            <span>{{item.type}}</span>
                                        </div>
                                        <div class="giftlist-body-member-second">
                                            <span>{{item.date}}</span>
                                            <br>
                                            <span>{{item.city}}</span>
                                        </div>
                                    </td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>		

    </Layout>
</template>

<style lang="scss" scoped>


.ext {
    text-align: center
}

.int {
    margin: 0 auto;
    text-align: left;
    position: relative;
    max-width: 1170px;
}

div.busca-lista { min-height: 300px; }

.busca-lista .giftlistinfo-title {
    display: block;
    font-size: 30px;
    z-index: 2;
    text-transform: lowercase;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-130%)
}

.busca-lista .giftlistinfo-title:after {
    content: '';
    display: block;
    background-image: url('https://www.lavillecasa.com.br/arquivos/arabesco-list-married.png');
    width: 77px;
    height: 22px;
    margin: 5px auto;
}

.busca-lista h2.titulo-lista {
    color: #fff;
    padding-left: 5%
}

.busca-lista {
    background: #FFF;
    overflow: hidden;
    padding: 0px 0px 40px 0px;
}

.busca-lista .giftlistinfo {
    background: #fff;
    position: relative;
    overflow: hidden;
    color: #333;
    background-size: 56px;
    background-image: -webkit-linear-gradient(0,transparent 50%,#000 50%);
    background-image: -moz-linear-gradient(0 50%,transparent 50%,rgba(255,255,255,.5) 50%);
    background-image: -ms-linear-gradient(0,transparent 50%,rgba(255,255,255,.5) 50%);
    background-image: -o-linear-gradient(0,transparent 50%,rgba(255,255,255,.5) 50%);
    height: 250px
}

.busca-lista .giftlistinfo-members {
    padding: 70px 0;
    margin: 0 auto;
    background: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    right: 50%;
    transform: translate(-50%,-50%);
    max-width: 38%;
    min-width: 440px;
    webkit-box-shadow: 6px 6px 61px -8px rgba(0,0,0,.6);
    -moz-box-shadow: 6px 6px 61px -8px rgba(0,0,0,.6);
    box-shadow: -4px 6px 61px -8px rgba(0,0,0,.6)
}

.busca-lista .list-members ul {
    font-size: 0;
    display: none
}

.busca-lista.user-exclusivo .giftlistinfo-members {
    border-right: 1px solid #A8A499;
    width: 500px
}

.busca-lista h3.new-info-name {
    font-weight: 400;
    font-size: 17px;
    margin-bottom: 2px;
    margin-top: 70px;
    text-transform: uppercase;
    text-align: center
}

.busca-lista .inputbusca {
	position: absolute;
    left: 50%;
    transform: translate(-50%,-50%);
    top: 55%;
	padding: 7px 0;
	border: 1px solid #d2d2d2;	
    text-indent: 10px;
    color: #040404;
    width: 70%;
    font-family: regular,sans-serif;
    height: 28px;
	background: url('https://www.lavillecasa.com.br/arquivos/iconSearch_cinza.png') no-repeat right -44px bottom -7px;
	font-size: 12px;
}

.busca-lista .btnbusca {
	position: absolute;
    left: 50%;
    transform: translate(-50%,-50%);
    top: 80%;
    background: #923a3a;
    color: #fff;
    height: 37px;
	width: 135px;
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;	
}

.busca-lista .btnbusca img {
    float: left;
    margin-left: 15px;
    margin-top: 8px;
    margin-right: 10px;
}

.busca-lista .btnbusca p {
    float: left;
    font-size: 9px;
    margin-top: 13px;
}

.busca-lista .blfbutton1 {
    vertical-align: top;
    width: 12%;
    margin-top: 49px;
}


.listasdomesconteudo {
    width: initial;
    position: initial;
    overflow-y: initial;
    height: initial;
    background: #FFF;
    border: none;
    border-radius: initial;
    box-shadow: none;
    cursor: pointer;
    text-transform: uppercase;
    font-family: "Nunito Sans", sans-serif;
}

.listasdomesconteudo .giftlist-table {
    width: 100%
}

.listasdomesconteudo th {
    text-transform: uppercase;
    color: #A8A499;
    font-weight: 700;
    padding: 25px 10px 25px 0;
    font-size: 15px
}

.listasdomesconteudo td {
    padding: 20px;
    border-top: 1px solid #f3f3f3;
    font-size: 16px;
    color: #A8A499
}

.listasdomesconteudo .giftlist-header { display: none; }

.listasdomesconteudo th.giftlist-header-image,.tooltip {
    color: #fff
}

.listasdomesconteudo td.giftlist-body-image,.listasdomesconteudo th.giftlist-header-image {
    display: block!important
}

.listasdomesconteudo td.giftlist-body-image img {
    border-radius: 50%;
    width: 140px !important;
    height: 140px !important;
    border: 3px solid #bcb4a3 !important;
}

.listasdomesconteudo td.giftlist-body-image.no-image::after {
    content: "";
    display: block;
    border-radius: 50%;
    width: 80px!important;
    height: 80px!important;
    border: 1px solid #ccc!important;
    background: url(https://www.lavillecasa.com.br/arquivos/list-no-image.png) 45% 30% no-repeat;
    background-size: 200%
}

.listasdomesconteudo td.giftlist-body-eventcity::before,.listasdomesconteudo th.giftlist-header-member::before {
    display: block;
    height: 29px;
    float: left;
    margin-right: 10px;
    margin-top: -10px;
    content: ""
}

.listasdomesconteudo td.giftlist-body-member span {
    font-family: "Nunito Sans", sans-serif;
    text-transform: uppercase;
    letter-spacing: .7px;
    font-size: 14px;
    color: #bcb4a3;
}

.listasdomesconteudo td.giftlist-body-member p {
    text-transform: capitalize;
    font-family: "Dancing Script", serif;
    font-size: 33px;
    color: #646161;
}

.listasdomesconteudo .giftlist-body-member-main {
    float: left;
}

.listasdomesconteudo .giftlist-body-member-second {
    float: right;
    text-align: right;
    margin: 10px 10px;
}

.listasdomesconteudo th.giftlist-header-member {
    padding: 0;
    vertical-align: text-top
}

.listasdomesconteudo table {
    margin: auto
}

.listasdomesconteudo .giftlist-body tr:hover {
    background: #eee
}

@media only screen and (max-width: 700px) {

    .listasdomesconteudo td.giftlist-body-member p {
        font-size: 25px;
    }    

    .listasdomesconteudo .giftlist-body-member-second {
        float: left;
        clear: both;
        text-align: left;
        margin: 10px auto;
    }

    .listasdomesconteudo td.giftlist-body-image img {
        height: 90px !important;
    }

}

</style>

